// Single place that knows the creator-type block of a creative name: `<type>-<Name>` (influencer-Jeremy, freelancer-Jeremy…).
// Timbo only emits DEFAULT_CREATOR_TYPE today. Adding a type = one line in CREATOR_TYPES (mirror in backend/creatorType.js).
export const CREATOR_TYPES = ['influencer'];
export const DEFAULT_CREATOR_TYPE = 'influencer';

const ALT = CREATOR_TYPES.join('|');

// Scope filter: is this a Timbo creator ad? (Meta ad names look like `<coreId>_<owner>_<type>-<Name>_…`)
const SCOPE_RE = new RegExp(`_(?:${ALT})-`, 'i');
export const isCreatorAd = (name) => SCOPE_RE.test(name || '');

// Display/parsing is type-agnostic: any lowercase `<type>-` after `<coreId>_<owner>_` is tolerated.
export const AD_PREFIX_RE = /^\d+_[a-z]+_(?:[a-z]+-)?/i;
export const stripAdPrefix = (name) => (name || '').replace(AD_PREFIX_RE, '');

const CREATOR_RE = /^\d+_[a-z]+_([a-z]+)-([^_]+)/i;
export function creatorBlock(name) {
  const m = (name || '').match(CREATOR_RE);
  return m ? { type: m[1].toLowerCase(), creator: m[2] } : null;
}
